import { Col, DatePicker, Form, Row, TimePicker } from 'antd'

import moment, { Moment } from 'moment'

interface EAReportDateTimeFilterProps {
  disabled?: boolean
  disableTime?: boolean
  endDate?: Moment
  endHour?: Moment
  startDate?: Moment
  startHour?: Moment
}

const EAReportDateTimeFilter = ({
  disabled = false,
  disableTime = false,
  endDate = moment().endOf('month'),
  endHour = moment('23:59:59', 'HH:mm:ss'),
  startDate = moment().startOf('month'),
  startHour = moment('00:00:00', 'HH:mm:ss'),
}: EAReportDateTimeFilterProps) => (
  <Row gutter={16}>
    <Col xs={24} md={12}>
      <Form.Item
        initialValue={startDate}
        label="Data inicial"
        name="startDate"
        rules={disabled ? [] : [{ required: true }]}
      >
        <DatePicker disabled={disabled} format="DD/MM/yyyy" style={{ width: '100%' }} />
      </Form.Item>
    </Col>

    <Col xs={24} md={12}>
      <Form.Item initialValue={endDate} label="Data final" name="endDate" rules={disabled ? [] : [{ required: true }]}>
        <DatePicker disabled={disabled} format="DD/MM/yyyy" style={{ width: '100%' }} />
      </Form.Item>
    </Col>

    {disableTime ? null : (
      <>
        <Col xs={24} md={12}>
          <Form.Item
            initialValue={startHour}
            label="Hora inicial"
            name="startHour"
            rules={disabled ? [] : [{ required: true }]}
          >
            <TimePicker disabled={disabled} style={{ width: '100%' }} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            initialValue={endHour}
            label="Hora final"
            name="endHour"
            rules={disabled ? [] : [{ required: true }]}
          >
            <TimePicker disabled={disabled} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </>
    )}
  </Row>
)

export default EAReportDateTimeFilter
